<!-- 部门列表 -->
<template>
	<div class='page_content'>
		<departmentAction  ref="departmentAction" ></departmentAction>
		<div class="page_content_top">
			<v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" label-width="100px">
					<el-form-item label="名称">
                        <label slot="label" :style="$common.labelStyle('名称')"
                            v-html="'名称'"></label>
						<el-input v-model.trim="getRequestData.depName"  size="mini" placeholder=""></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border  style="width: 100%" highlight-current-row>
				<el-table-column align="center" label="选择操作"  width="80">
					<template  slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column align="center"  type="index"  label="编号" width="80">
				</el-table-column>
				<el-table-column align="center" prop="depCode" label="编码"  >
				</el-table-column>
				<el-table-column align="center" prop="depName" label="名称" >
				</el-table-column>
				<el-table-column align="center" prop="depState" label="状态" >
					<template slot-scope="scope">
						<el-tag size="mini">{{$store.state.departmentStatus[scope.row.depState].name}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="ormName" label="组织" >
				</el-table-column>
				<el-table-column align="center" prop="parentName" label="部门归属" >
				</el-table-column>
				<el-table-column align="center" prop="depSuject" label="科目" >
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import departmentAction from "@/components/departmentAction.vue";
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {departmentAction},
	data() {
		var _this = this
		//这里存放数据
		return {
            tableHeight:0,
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'',
				actionType:0, // 0新增，1修改
			},
			
			
			selectedDataList:[],
			
			buttonList:[],
			getRequestData:{
				depName:'',
				depState:'',
				page:1,
				rows:30,
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			allorgList:[],
			allDepartmentList:'',
			selectDepartmentPath:'',
			selectOrgPath:[0],
			selectedDataIndex:0
			
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		
		
		// 动作集合
		actionSet(actionData){
			switch(actionData.actionType){
				case 0:
					this.$refs['departmentAction'].openBox(actionData.actionType)
					break;
				case 1:
					if(this.returnData.list<=0){
						this.$message({
							message: '暂无数据',
							type: 'error'
						});
						return false
					}
					var  dataInfo = this.returnData.list[this.selectedDataIndex]
					if(!dataInfo){
						this.$message({
							message: '请先选中要操作的数据',
							type: 'error'
						});
						return false
					}
					this.$refs['departmentAction'].openBox(actionData.actionType,dataInfo)
					break;
				case 2:
					this.delDataAction()
					break;
				case 3:
					this.setDataAction()
					break;
			}
		},
		
		// 修改状态
		async setDataAction(){
			if(this.returnData.list<=0){
				this.$message({
					message: '暂无数据',
					type: 'error'
				});
				return false
			}
			var  dataInfo = this.returnData.list[this.selectedDataIndex]
			if(!dataInfo){
				this.$message({
					message: '请先选中要操作的数据',
					type: 'error'
				});
				return false
			}
			var sendData = {
				ids:[dataInfo.depId]
			}
			let responseData =  await this.$http.setDepartmentStatus(sendData)
			if(responseData.status == 200){
				this.$message({
					type: 'success',
					message: '操作成功!'
				});
				this.getDataList()
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
		},
		async getButtonList(){
			this.buttonList = await this.$common.getActionButton()
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		
		// 删除数据
		delDataAction(){
			if(this.returnData.list<=0){
				this.$message({
					message: '暂无数据',
					type: 'error'
				});
				return false
			}
			var  dataInfo = this.returnData.list[this.selectedDataIndex]
			if(!dataInfo){
				this.$message({
					message: '请先选中要操作的数据',
					type: 'error'
				});
				return false
			}
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async()=> {
				var delData = {
					ids:[dataInfo.depId]
				}
				let responseData =  await this.$http.delDepartment(delData)
				if(responseData.status == 200){
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					this.getDataList()
				}else{
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
				
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			}).catch(() => {});
			
		},
	
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getDepartmentList(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
				this.selectedDataIndex = 0
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getDataList()
		this.getButtonList()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {this.tableHeight = this.$common.getTableHeight()}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>

</style>
